export type Plan = {
	id: number;
	amount: number;
	price_id: string;
	currency: string;
	interval: string;
	nickname: string;
	isCurrentPlan: boolean;
	isUpgradeable: boolean;
	number_of_applications: number;
};

export type PlanInterval = 'Monthly' | 'Yearly';

export const PLAN_PERKS: Record<string, string[]> = {
	'Assets ID Basic': [
		'1 property included',
		'Unlimited asset documentation',
		'Secure cloud storage backup',
		'Professional appraisal tracking',
		'Instant claims report generation',
		'24/7 mobile app access',
		'Annual asset value updates',
		''
	],
	'Assets ID Pro': [
		'2 properties included',
		'Unlimited asset documentation',
		'Secure cloud storage backup',
		'Professional appraisal tracking',
		'Instant claims report generation',
		'24/7 mobile app access',
		'Annual asset value updates',
		'Priority support'
	]
};

export const PLAN_TAGLINES: Record<string, string> = {
	'Assets ID Basic': 'Complete asset protection for homeowners',
	'Assets ID Pro': 'Advanced protection for multiple properties'
};

export interface Card {
	brand: string;
	country: string;
	default: boolean;
	display_brand: string;
	exp_month: number;
	exp_year: number;
	image: string;
	last4: string;
	payment_method_id: string;
}

export interface Subscription {
	plan_price: number;
	frequency: string;
	currency: string;
	current_period_end: string;
	plan_name: string;
	subscription_id: string;
	next_billing_date: string;
	is_renewable?: number;
}

export interface Invoice {
	id: string;
	invoice_number: string;
	amount_paid: number;
	status: string;
	currency: string;
	invoice_created_date: string;
	invoice_pdf: string;
	plan_name: string;
}

